"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformConfigData = transformConfigData;
var _orderSummaryData = _interopRequireDefault(require("./order-summary-data"));
var _productConfigurationData = _interopRequireDefault(require("./product-configuration-data"));
/**
 * Transforms raw configuration data into a structured format.
 *
 * @param {Object} rawData The raw data to be transformed.
 * @returns {Object} A transformed configuration object.
 */
function transformConfigData(rawData) {
  const responseData = rawData?.response;
  if (!responseData) return {};
  const {
    data,
    instance,
    environment,
    content,
    disclaimers
  } = responseData;
  const product = Object.keys(instance)[0]; // Remove this once we have a way to handle multiple products
  const orderSummaryData = (0, _orderSummaryData.default)(responseData);
  const productConfigurationData = (0, _productConfigurationData.default)(responseData);
  const {
    title,
    pageHeadline
  } = data[product]?.content || {};
  const transformed = {
    pageEyebrow: {
      pageTagLabel: content.addedToCart || 'Added to cart',
      pageTitle: title || 'Customize your plan'
    },
    itemSummary: {
      orderSummary: content?.orderSummary,
      total: content?.total,
      totalPrice: orderSummaryData[product].totalPrice,
      legalTaxText: content?.legalTaxText,
      totalSavings: orderSummaryData[product].totalSavings,
      totalSavingsBanner: content?.totalSavingsBanner,
      items: orderSummaryData[product].selections,
      fixedCheckoutDescription: content?.scrollToCart
    },
    productConfiguration: {
      pageHeadline: pageHeadline || 'Product configuration',
      itemRows: productConfigurationData[product].itemRows
    },
    disclaimers,
    commonContent: content,
    instance,
    environment,
    product
  };
  return transformed;
}